import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import { trackCTAClick } from "../utils/analytics";

const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  // Don't show on the form pages themselves or admin pages
  const hiddenPaths = ["/contact", "/path-score", "/area-score", "/score-a-corridor", "/start-your-project", "/talent-network", "/admin"];
  const isHidden = hiddenPaths.some(p => location.pathname.startsWith(p));

  useEffect(() => {
    if (isHidden || dismissed) return;

    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHidden, dismissed]);

  if (isHidden || dismissed || !visible) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-4 duration-300"
      data-testid="sticky-cta"
    >
      <div className="relative">
        <button
          onClick={() => setDismissed(true)}
          className="absolute -top-2 -right-2 bg-slate-700 hover:bg-slate-600 rounded-full w-6 h-6 flex items-center justify-center text-slate-400 hover:text-white transition-colors z-10"
          aria-label="Dismiss"
          data-testid="sticky-cta-dismiss"
        >
          <X className="h-3.5 w-3.5" />
        </button>
        <Link
          to="/contact?source=sticky_cta"
          onClick={() => trackCTAClick('sticky_cta')}
          className="flex items-center font-semibold py-3 px-6 rounded-full shadow-lg transition-all hover:scale-105"
          style={{ background: 'var(--ols-copper)', color: '#fff', boxShadow: '0 8px 24px rgba(184, 98, 47, 0.35)' }}
          data-testid="sticky-cta-link"
        >
          Talk to Onward
          <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default StickyCTA;
